import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { Construction } from 'src/models/resort/Construction';
import { UserResortMyProfile } from 'src/models/resort/UserResortMyProfile';
import { ResortConstructionGridItems } from './ResortConstructionGridItems';
import { ResortUserInfo } from './ResortUserInfo';

interface ResortMyPromotionContentProps {
  basePath: string; // 施工事例詳細画面のパスのプレフィックス
  profile: UserResortMyProfile;
}

export const ResortMyPromotionContent: React.FC<ResortMyPromotionContentProps> = ({
  basePath,
  profile
}) => {
  const { t } = useTranslation('resort');
  const history = useHistory();
  const handleItemClick = useCallback(
    (construction: Construction) => {
      history.push(`${basePath}/my-constructions/${construction.resortId}`);
    },
    [basePath, history]
  );

  const userColor = getResortUserColor(profile.resortPlannerPromotionColor);

  return (
    <div
      className={css`
        width: 100%;
        max-width: 480px;
        color: #4d3906;
        margin: 0 auto;
        padding: 32px 16px;

        .grid-label {
          font-size: 14px;
          margin: 32px 0 8px;
        }
      `}
    >
      <ResortUserInfo
        name={profile.name}
        image={profile.image}
        isMyself={true}
        resortPlannerGrade={profile.resortPlannerGrade ?? ''}
        resortPlannerId={profile.resortPlannerId ?? ''}
      />
      <div className="construction-list-container">
        <p className="grid-label">{t('resort_list')}</p>
        <ResortConstructionGridItems
          items={profile.constructions}
          userColor={userColor}
          onItemClick={handleItemClick}
        />
      </div>
    </div>
  );
};
